import { Scene } from "@babylonjs/core/scene";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Animation } from "@babylonjs/core/Animations/animation";
import { AbstractMesh } from "@babylonjs/core/Meshes/abstractMesh";
import { STEP_FRAMES } from "./constants";

// 箱の押しスライド：X/Z/Y 線形補間（ホッピング無し、腕アニメ無し）
// target.y はボタン乗降の補正（nextStepOffsetBox）込みの値
// speedRatio: アニメ速度倍率（デフォルト 1.0）
export const performBoxSlide = (
  scene: Scene,
  node: AbstractMesh,
  target: { x: number; y: number; z: number },
  speedRatio = 1,
): Promise<void> =>
  new Promise<void>((resolve) => {
    if (!scene || scene.isDisposed) return resolve();
    const anim = new Animation(
      "boxSlide",
      "position",
      STEP_FRAMES,
      Animation.ANIMATIONTYPE_VECTOR3,
      Animation.ANIMATIONLOOPMODE_CONSTANT,
    );
    anim.setKeys([
      { frame: 0, value: node.position.clone() },
      { frame: STEP_FRAMES, value: new Vector3(target.x, target.y, target.z) },
    ]);
    const a = scene.beginDirectAnimation(node, [anim], 0, STEP_FRAMES, false, speedRatio);
    a.onAnimationEnd = () => resolve();
  });
